import { render, staticRenderFns } from "./NationalTrademarkSearchStatusList.vue?vue&type=template&id=a9cc694e&"
import script from "./NationalTrademarkSearchStatusList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchStatusList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkSearchStatusList.vue?vue&type=style&index=0&id=a9cc694e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports